import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root',
})
export class IconService {
	constructor(
		private readonly matIconRegistry: MatIconRegistry,
		private readonly domSanitizer: DomSanitizer,
	) {}

	// eslint-disable-next-line max-lines-per-function
	registerIcons(): void {
		this.matIconRegistry.addSvgIcon(
			'sanus-add-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-add-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-add-gray',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-add-gray.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-alert-gray',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-alert-gray.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-alert-red',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-alert-red.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-back',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-back.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-bell',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-bell.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-building-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-building-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-bullet',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-bullet.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-bullet-off',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-bullet-off.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-business',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-business.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-business-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-business-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-calendar-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-calendar-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-chevron-down',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-chevron-down.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-chevron-down-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-chevron-down-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-chevron-down-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-chevron-down-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-chevron-right',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-chevron-right.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-chevron-right-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-chevron-right-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-close',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-close.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-closeb',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-closeb.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-cog',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-cog.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-download',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-download.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-edit-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-edit-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-error',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-error.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-exit',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-exit.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-filter-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-filter-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-financial',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-financial.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-financial-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-financial-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-home',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-home.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-home-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-home-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-info',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-info.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-invisible',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-invisible.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-life',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-life.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-life-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-life-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-location-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-location-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-lock',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-lock.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-lock-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-lock-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-log',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-log.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-menu',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-menu.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-more-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-more-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-next',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-next.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-person-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-person-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-privacy-policy',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-privacy-policy.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-register',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-register.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-success',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-success.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-trash',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-trash.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-trash-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-trash-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-trash-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-trash-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-upload',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-upload.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-user',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-user.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-visible',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-visible.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-wage-blue',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-wage-blue.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-wellness',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-wellness.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-wellness-white',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-wellness-white.svg',
			),
		);
		this.matIconRegistry.addSvgIcon(
			'sanus-movimentations',
			this.domSanitizer.bypassSecurityTrustResourceUrl(
				'../assets/icons/sanus-movimentations.svg',
			),
		);
	}

	setDefaultFont() {
		this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
	}
}
